import { useId, useState } from 'react';

import { cx } from '../lib/cx.js';
import { CATEGORY_EMOJI_GROUPS, normalizeCategoryEmoji } from './icons/categoryEmoji.js';
import styles from './EmojiPicker.module.css';

/**
 * Picking the icon of a category: a shortlist to tap, and a field for anything else.
 *
 * The field is the important half — it opens the phone's own emoji keyboard, which is why
 * this screen does not need a thousand-icon grid to offer a thousand icons.
 */
export function EmojiPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (emoji: string) => void;
}) {
  const customId = useId();
  const [custom, setCustom] = useState('');

  return (
    <div className={styles.wrapper}>
      {/* Scrolls inside itself, never taking the page with it. */}
      <div className={styles.groups}>
        {CATEGORY_EMOJI_GROUPS.map((group) => (
          <div key={group.label}>
            <p className={styles.groupLabel}>{group.label}</p>
            <div className={styles.grid} role="group" aria-label={`Biểu tượng — ${group.label}`}>
              {group.emojis.map((emoji) => (
                <button
                  key={emoji}
                  type="button"
                  className={cx(styles.cell, value === emoji && styles.cellActive)}
                  aria-label={`Biểu tượng ${emoji}`}
                  aria-pressed={value === emoji}
                  onClick={() => onChange(emoji)}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.customRow}>
        <label className={styles.customLabel} htmlFor={customId}>
          Hoặc nhập emoji khác
        </label>
        <input
          id={customId}
          className={styles.customInput}
          type="text"
          value={custom}
          placeholder="🍔"
          autoComplete="off"
          inputMode="text"
          onChange={(event) => {
            setCustom(event.target.value);
            const emoji = normalizeCategoryEmoji(event.target.value);
            if (emoji) {
              onChange(emoji);
              setCustom(emoji);
            }
          }}
        />
      </div>
    </div>
  );
}
